import { Outlet } from 'react-router'
import { Container } from '@/components/ui'
// import {  IS_PROD } from '@/constants/env'
import { Header } from '@/components/layout/header'
// import Banners from '@/components/banners/Banners'
// import { FsspRegText } from './articles/FsspRegText'
import s from './auth.module.scss'

const AuthLayout = () => {
  // const location = useLocation()

  // useEffect(() => {
  //   removeToken()
  // }, [])

  return (
    <>
      <Header isAuth />
      <div className={s.auth}>
        <Container fluid>
          <div className={s.auth__wrapper}>
            <div className={s.auth__content}>
              <div className={s.modal}>
                {/* {IS_FSSP && <FsspRegText />}
                {!IS_FSSP &&
                  ((IS_PROD &&
                    location.pathname ===
                      '/auth/7571b2c5-587f-11ef-8d73-02420a00029f/9683c950-587f-11ef-8d73-02420a00029f') ||
                    (IS_PROD &&
                      location.pathname ===
                        '/auth/66f3abd6-e5d3-11ed-9f22-02420a0001fd/fc415798-e5d3-11ed-9f22-02420a0001fd')) && (
                    <Banners type='neuroSchool' />
                  )} */}
                <Outlet />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  )
}

export default AuthLayout
